import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const closeTableSplit = (splitId, tableId, data, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .post(`/tables/${tableId}/splits/${splitId}/close`, data)
}

export default closeTableSplit
